import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import axios from 'axios';
import Footer from 'components/navigation/Footer';
import Layout from 'hocs/Layouts/Layout';
import '../../styles/login.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { email, password } = formData;

  const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async e => {
    e.preventDefault();
    setError('');

    try {
      // 1️⃣ Solicita el token al backend
      const res = await axios.post(
        `${API_BASE}/auth/jwt/create/`,
        { email, password },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const { access, refresh, role, correo } = res.data;

      // 2️⃣ Guarda los datos
      localStorage.setItem('access', access);
      localStorage.setItem('refresh', refresh);
      localStorage.setItem('role', role);
      localStorage.setItem('correo', correo);

      setIsAuthenticated(true);
    } catch (err) {
      console.error('❌ Error en login:', err);
      setError('Credenciales inválidas o error de conexión.');
    } finally {
      setLoading(false);
    }
  };

  // 3️⃣ Redirección según el rol
  if (isAuthenticated) {
    const role = localStorage.getItem('role');
    if (role === 'admin') return <Navigate to="/admin" />;
    if (role === 'digitador') return <Navigate to="/digi" />;
    if (role === 'val') return <Navigate to="/valPage" />;
    if (role === 'terpel') return <Navigate to="/terpel" />;
    return <Navigate to="/" />;
  }

  return (
    <Layout>
      <div className="login-container">
        <h1 className="login-title">Iniciar Sesión</h1>
        <form onSubmit={onSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Correo</label>
            <input
              id="email"
              name="email"
              value={email}
              type="email"
              required
              onChange={onChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              name="password"
              value={password}
              type="password"
              required
              onChange={onChange}
            />
          </div>
          <button type="submit" className="login-button">
            Ingresar
          </button>
          {error && <p className="error">{error}</p>}
        </form>
        <Link to="/" className="home-button">Regresar a Inicio</Link>
      </div>
      <Footer />
    </Layout>
  );
}

export default Login;
